import React from 'react'
import styles from './style'
import { withStyles } from '@material-ui/core'
import propTypes from './prop'

import { useCardSettings } from 'src/hooks/useCardSettings'
import Alert from '@material-ui/core/Alert'

import SettingsIcon from '@material-ui/icons/Settings'
import { CoreButton } from 'src/components/core'
/**
 *
 * @param {*} props
 */
const ProtectionCard = props => {
  const { dispatch, entity, classes } = props

  const settings = useCardSettings('cardSettings')

  const configured = settings ? JSON.parse(settings.value) : null
  const handleClick = () => {
    const element = document.getElementById('setting-button')
    if (element) {
      element.click()
    }
  }
  return (
    <>
      {!configured || (configured && configured.password == '') ? (
        <Alert
          className={classes.setPassword}
          severity="info"
          action={
            <CoreButton color="info" onClick={() => handleClick()}>
              Set Password
            </CoreButton>
          }
        >
          Click 'Set Password' to create your password. You can change it at any
          time.
        </Alert>
      ) : (
        configured && (
          <Alert
            severity="success"
            className={classes.setPassword}
            action={
              <CoreButton color="success" onClick={() => handleClick()}>
                Settings
              </CoreButton>
            }
          >
            Password is set. Users can reach the rest of the content with the
            password.
          </Alert>
        )
      )}
    </>
  )
}

ProtectionCard.propTypes = propTypes

export default withStyles(styles)(ProtectionCard)
